import { useEffect, useState, useContext } from 'react';
import {
  Select,
  Grid,
  MenuItem,
  InputLabel
} from '@mui/material';
import { AuthContext } from 'components';


const ColorComponent = (props) => {
  const { 
    color, 
    text,
    selected = true,
    size = 20,
  } = props

  const handleClick = function() {
    if (props.onClick) {
      props.onClick(color)
    }
  }

  const style = {
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    msUserSelect: "none",
    width: `${size}px`,
    height: `${size}px`,
    margin: '0 5px',
    cursor: 'pointer',
    borderRadius: '50%',
    boxShadow: selected ? '0px 0px 10px 5px #6366F1' : 'none',
  }

  if (color.imageName) {
    let color_img = `https://firebasestorage.googleapis.com/v0/b/faves-pro.appspot.com/o/colors%2F${color.imageName}.png?alt=media`

    return (
      <Grid style={{ width: 'auto' }} container spacing={1}>
        <Grid item>
          <img 
            style={style}
            src={color_img} 
            alt=''
            onClick={handleClick}
            onError={(e) => {
              console.log(e)
              console.log(color)
            }}
          />
        </Grid>
        <Grid item>
          <span>{text}</span>
        </Grid>
      </Grid>
    )
  }
  return (
    <Grid style={{ width: 'auto' }} container spacing={1}>
        <Grid item>
          <div onClick={handleClick} key={color && color.displayName} style={{ 
            ...style,
            background: `#${color && color.hex}`
          }}></div>
        </Grid>
        <Grid item>
          <span>{text}</span>
        </Grid>
      </Grid>
  )
}

export const ColorsField = (props) => {
  const { colors } = useContext(AuthContext);
  const [ value, setValue ] = useState(props.colors || [])

  useEffect(() => {
    setValue(props.colors || [])
  }, [props.colors])

  return (
    <>
      <InputLabel shrink variant="standard">Colors</InputLabel>
      <Select 
        labelId="color-label"
        label="Colors"
        value={value}
        variant="standard" 
        sx={{width: '100%'}}
        renderValue={(value) => {
          return (
            <div style={{ display: "flex" }}>
              {value.map((color_id) => (
                <ColorComponent 
                  key={`color-${color_id}`}
                  color={colors[color_id]}
                  selected={false}
                  size={20}
                />
              ))}
            </div>
          )
        }}
        onChange={(event) => {
          const {
            target: { value },
          } = event;

          let filtered_value = value.filter(e => Number.isInteger(parseInt(e)))
          if (props.onChange) { props.onChange(filtered_value) }
          setValue(filtered_value)
        }}
        multiple
      >
        {Object.keys(colors).sort((a, b) => {
            if (colors[a].displayName < colors[b].displayName) {
              return -1;
            } else if (colors[a].displayName > colors[b].displayName) {
              return 1;
            } else {
              return 0;
            }
          }).map((color_id) => (
          <MenuItem key={`color-${color_id}`} value={parseInt(color_id)}>
            <ColorComponent 
              text={colors[color_id].displayName}
              color={colors[color_id]}
              selected={false}
              size={20}
            />
          </MenuItem>
        ))}
      </Select>
    </>
  )
}